import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-bhawna',
  templateUrl: './bhawna.component.html',
  styleUrls: ['./bhawna.component.scss']
})
export class BhawnaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getBhawna();
  }
}
